import classNames from 'classnames';
import { ReactNode } from 'react';

export type BadgeVariant =
  | 'success'
  | 'success-inverted'
  | 'warning'
  | 'info'
  | 'info-inverted'
  | 'error'
  | 'neutral'
  | 'alert'
  | 'alert-inverted'
  | 'neutral-inverted'
  | 'error-inverted';

type Props = {
  children: ReactNode;
  variant: BadgeVariant;
  testId?: string;
};

export const Badge = ({ children, testId, ...props }: Props) => {
  return (
    <div
      className={classNames(
        'd-inline-flex justify-content-center align-items-center u-fs-1 fw-bold py-0 px-2 u-border-r-11',
        {
          'u-bg-pine1 u-color-pine5': props.variant === 'success',
          'u-bg-pine5 u-color-white': props.variant === 'success-inverted',
          'u-bg-maple2 u-color-maple4': props.variant === 'alert',
          'u-bg-maple4 u-color-white': props.variant === 'alert-inverted',
          'u-bg-red0 u-color-bark4': props.variant === 'warning',
          'u-bg-blue0 u-color-blue1': props.variant === 'info',
          'u-bg-blue1 u-color-white': props.variant === 'info-inverted',
          'u-bg-red0 u-color-red1': props.variant === 'error',
          'u-bg-bark1 u-color-bark3': props.variant === 'neutral',
          'u-bg-bark3 u-color-white': props.variant === 'neutral-inverted', // neutral-inverted
          'u-bg-red1 u-color-white': props.variant === 'error-inverted', // PENDING
        },
      )}
      data-testid={testId}
    >
      {children}
    </div>
  );
};
